module.exports = __webpack_public_path__ + "media/Teil 6.3edf8665.mp4";